import type { IPartner } from 'shared/types'
import { client } from '../clients'

const getList = () => client.get<IPartner[]>('/partners/all')

export const partners = {
  getList
}
